import CheckRequirements from './CheckRequirements';

export default CheckRequirements;
export { CheckRequirements };
